import { Component } from '@angular/core';

@Component({
  selector: 'app-page-notfound',
  templateUrl: './page-notfound.component.html',
  styleUrl: './page-notfound.component.scss'
})
export class PageNotfoundComponent {
  quotes: string[] = [
    "Lost in the vast web,\nWhere you sought, there's only void—\nNothingness awaits.",
    "The page you are looking for is like a shadow,\nUnseen and beyond reach.",
    "404 - Like a needle in a haystack,\nYou’re searching for something lost in time.",
    "Not all paths are meant to be found,\nSometimes they lead to endless loops.",
    "The web is vast and mysterious,\nSometimes even the best explorers get lost.",
    "Beyond the realms of known links,\nThe page you sought slips away into the ether.",
    "The search continues,\nBut the destination remains elusive.",
    "Like a forgotten dream,\nThe page has vanished without a trace.",
    "Your journey ends here,\nThe page is but a memory lost in cyberspace.",
    "This page is like a ghost,\nOnly visible to the imagination.",
    "In the labyrinth of the web,\nThis link leads to nowhere.",
    "No maps, no clues,\nJust endless empty space.",
    "A treasure once found,\nNow buried in the digital sand.",
    "In the vast expanse of the internet,\nThis page is a distant star—out of reach.",
    "The link you followed has crossed into another dimension,\nLeaving nothing but a void.",
    "404: The page that never was,\nA figment of the web's imagination.",
    "The web hides its secrets well,\nAnd this one has slipped through its cracks.",
    "You have wandered far and wide,\nBut this page is lost to time.",
    "The page you've searched for,\nHas been swallowed by the infinite digital ocean.",
    "The winds of the internet have swept it away,\nLeaving only this empty space behind."
  ];


  currentQuote: string = '';
  // getRandomQuote() {
  //   const randomIndex = Math.floor(Math.random() * this.quotes.length);
  //   return this.quotes[randomIndex];
  // }

  // ngOnInit(): void {
  //   this.currentQuote = this.getRandomQuote();
  // }

  ngOnInit(): void {
    this.currentQuote = '';
    const randomQuote = this.getRandomQuote();
    this.typeWriter(randomQuote);
  }

  getRandomQuote(): string {
    const randomIndex = Math.floor(Math.random() * this.quotes.length);
    return this.quotes[randomIndex];
  }

  typeWriter(text: string, i: number = 0) {
    if (i < text.length) {
      this.currentQuote += text.charAt(i);
      setTimeout(() => this.typeWriter(text, i + 1), 50);
    }
  }
}
